import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  bottomContentMobile: {
    width: '100%',
    height: '40%',
    flex: 1,
    flexGrow: 1,
    alignSelf: 'center',
    zIndex: 99,
    borderTopLeftRadius: 32,
    borderTopRightRadius: 32,
    overflow: 'scroll',
    scrollBehavior: 'smooth',
    backgroundColor: theme.palette.background.default,
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  bottomContentMobileXs: {
    position: 'absolute',
    bottom: 0,
    left: 0,
  },
  bottomContentMobileSm: {
    position: 'absolute',
    bottom: 0,
    left: '20%',
    right: '20%',
  },
  floatingButtonMobile: {
    width: 48,
    height: 48,
    position: 'absolute',
    left: 8,
    top: 0,
    backgroundColor: theme.palette.background.default,
    borderRadius: 32,
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    padding: 8,
  },
  dividerContainer: {
    position: 'absolute',
    top: 0,
    left: '40%',
    zIndex: 99,
    width: '20%',
    height: 14,
  },
}));
